export const wrapper = {
	display: 'block',
};

export const getGoogleMapStyles = (isSmallScreen?: boolean) => ({
	height: isSmallScreen ? '18.75rem' : '100%',
});
